// PlanComponents/RecommendedSkillsCard.js
import React from 'react';
import { Typography, Table, TableBody, TableRow, TableCell, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import StarIcon from '@mui/icons-material/Star';
import { bg } from '../../../utils/darkModeAdapter';

import CardItem from './CardItem';
import AdviceContentBox from '../../../components/AdviceContentBox';

// レベル正規化関数を追加
function normalizeLevel(level) {
  // nullやundefined、空文字の場合
  if (!level || typeof level !== 'string') {
    return 'B';
  }
  
  // A、B、C以外の文字が来た場合は強制的にA、B、Cに変換
  const upperLevel = level.toUpperCase().trim();
  
  // 有効なレベルのみ許可
  if (['A', 'B', 'C'].includes(upperLevel)) {
    return upperLevel;
  }
  
  // 不正な値（「あ」など）はデフォルトでBに変換
  console.warn(`Invalid skill level detected: "${level}", defaulting to "B"`);
  return 'B';
}

// 例えばレベルに応じた色分けをする関数
function levelToChipColor(level) {
  // A、B、C以外の値を強制的にBに正規化
  const normalizedLevel = normalizeLevel(level);
  
  switch (normalizedLevel) {
    case 'A': return '#f44336'; // red
    case 'B': return '#ffa726'; // orange
    case 'C': return '#ffeb3b'; // yellow
    default:  return '#ffa726';  // orange (Bと同じ色をデフォルト)
  }
}

export default function RecommendedSkillsCard({ skills, adv }) {
  const theme = useTheme();

  return (
    <CardItem
      title="推奨スキルセット"
      adviceContent={<AdviceContentBox adviceObj={adv.recommendedSkills} />}
    >
      {!Array.isArray(skills) || skills.length === 0 ? (
        <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
          未設定
        </Typography>
      ) : (
        <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
          <TableBody>
            {skills.map((s, i) => {
              const chipColor = levelToChipColor(s.level);
              return (
                <TableRow
                  key={i}
                  sx={{
                    backgroundColor: bg(theme).subtle,
                    '& td:first-of-type': {
                      borderTopLeftRadius: '8px',
                      borderBottomLeftRadius: '8px'
                    },
                    '& td:last-of-type': {
                      borderTopRightRadius: '8px',
                      borderBottomRightRadius: '8px'
                    }
                  }}
                >
                  <TableCell
                    sx={{
                      width: '80px',
                      border: 'none',
                      textAlign: 'center'
                    }}
                  >
                    <Chip
                      label={normalizeLevel(s.level)}
                      sx={{
                        backgroundColor: chipColor,
                        color: '#fff',
                        fontWeight: 'bold'
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <StarIcon sx={{ color: '#ffc107', mr: 1 }} />
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                      {s.skill}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </CardItem>
  );
}